module.exports = __webpack_public_path__ + "static/media/World.4ae516f0.svg";